export function isPasswordRecoveryRoute(pathname) {
  try {
    return /^\/(recuperar|redefinir)-senha\/*$/i.test(decodeURIComponent(pathname))
  } catch {
    return false
  }
}
